import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
const usePrograms = () => {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPrograms = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/program/get-all-program`, {
        timeout: 10000,
        headers: {
          'Content-Type': 'application/json',
        }
      });

      setPrograms(response.data || []);
    } catch (error) {
      console.error('Failed to fetch programs:', error);
      setError('Failed to load programs');

      // Fallback programs in case of API failure
      setPrograms([
        { _id: 'fallback-1', title: 'Full Stack Development' },
        { _id: 'fallback-2', title: 'Data Science' },
        { _id: 'fallback-3', title: 'Cloud Computing' },
      ]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPrograms();
  }, [fetchPrograms]);

  return { programs, loading, error, refetch: fetchPrograms };
};
export default usePrograms;